var map = {
	"./hezuo1.png": 4585,
	"./hezuo2.png": 3618,
	"./hezuo3.png": 4795,
	"./hezuo4.png": 4580,
	"./hezuo5.png": 8477,
	"./hezuo6.png": 4502,
	"./hezuo7.png": 7791,
	"./hezuo8.png": 7944,
	"./hezuo9.png": 1809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9799;